import { Button } from "@design";
import { ShieldAlert } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { ApiError } from "@/api";
import { useSignOut } from "@/auth/useSignOut";
import { CenteredScreen } from "@/components/CenteredScreen";
import { Text } from "@/components/Text";

/**
 * Shown instead of the app when the backend blocks this user (403 with a
 * platform block code). The title/message are translated from the CODE; the
 * backend's free-text detail (English) is shown as secondary context only.
 */
export function BlockedScreen({ error }: Readonly<{ error: ApiError }>) {
  const signOut = useSignOut();
  const { t } = useTranslation(["account", "common"]);
  const code = error.platformBlock ?? "USER_DEACTIVATED";
  return (
    <CenteredScreen>
      <span className="text-error">
        <ShieldAlert size={40} aria-hidden="true" />
      </span>
      <Text variant="h2" as="h1">
        {t(`blocked.${code}.title`)}
      </Text>
      <Text tone="secondary">{t(`blocked.${code}.message`)}</Text>
      {error.detail && (
        <Text variant="body-sm" tone="tertiary">
          {error.detail}
        </Text>
      )}
      <Button variant="secondary" onClick={() => signOut()}>
        {t("common:signOut")}
      </Button>
    </CenteredScreen>
  );
}
